<template>
  <base-print
    title="ITEM RETURN / RMA FORM"
    :document-number="item.id"
    :document-date="item.created_at"
    document-label="RMA No. "
    print-id="returnedItemPrint"
  >
    <!-- Item Info Table -->
    <table class="data-table" style="margin-top: 5px">
      <tr>
        <td style="width: 120px; font-weight: bold">Item</td>
        <td>{{ item.item ? item.item.item_name : "N/A" }}</td>
      </tr>
      <tr>
        <td style="font-weight: bold">Quantity</td>
        <td>{{ item.quantity }} pc/s</td>
      </tr>
      <tr>
        <td style="font-weight: bold">Serial No.</td>
        <td>{{ item.product_serial_number || "N/A" }}</td>
      </tr>
      <tr>
        <td style="font-weight: bold">Supplier</td>
        <td>{{ supplierName }}</td>
      </tr>
      <tr>
        <td style="font-weight: bold">Batch</td>
        <td>
          {{
            item.item && item.item.import_batch
              ? item.item.import_batch.batch_description
              : "N/A"
          }}
        </td>
      </tr>
    </table>

    <!-- Problem Description -->
    <div style="margin-top: 12px">
      <p style="font-weight: bold; margin: 0 0 4px 0; font-size: 10pt">
        Problem Description:
      </p>
      <div style="border: 1px solid #000; padding: 8px; min-height: 60px">
        <p style="margin: 0; white-space: pre-wrap; font-size: 10pt">
          {{ item.problem_description || "No description provided" }}
        </p>
      </div>
    </div>

    <!-- Details Row -->
    <table style="width: 100%; border: none; margin-top: 12px; font-size: 10pt">
      <tr>
        <td style="border: none; padding: 2px 0">
          <strong>Filed by:</strong> {{ item.technician || "N/A" }}
        </td>
        <td style="border: none; padding: 2px 0; text-align: right">
          <strong>Date:</strong> {{ formatDate(item.created_at) }}
        </td>
      </tr>
      <tr>
        <td style="border: none; padding: 2px 0">
          <strong>Status:</strong> {{ getStatusLabel() }}
        </td>
        <td style="border: none; padding: 2px 0; text-align: right">
          <span v-if="item.date_returned">
            <strong>Returned:</strong> {{ formatDate(item.date_returned) }}
          </span>
        </td>
      </tr>
    </table>

    <!-- Signatures -->
    <div style="margin-top: 40px">
      <table style="width: 100%; border: none">
        <tr>
          <td style="width: 50%; border: none; text-align: center">
            <div
              style="
                border-top: 1px solid #000;
                width: 180px;
                margin: 0 auto;
                padding-top: 5px;
                font-size: 9pt;
              "
            >
              Prepared By
            </div>
          </td>
          <td style="width: 50%; border: none; text-align: center">
            <div
              style="
                border-top: 1px solid #000;
                width: 180px;
                margin: 0 auto;
                padding-top: 5px;
                font-size: 9pt;
              "
            >
              Verified By
            </div>
          </td>
        </tr>
      </table>
    </div>
  </base-print>
</template>

<script>
import BasePrint from "./BasePrint.vue";
import moment from "moment";

export default {
  name: "PrintReturnedItem",
  components: {
    BasePrint,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    supplierName() {
      if (this.item.stock_lot && this.item.stock_lot.supplier) {
        return this.item.stock_lot.supplier;
      }
      if (this.item.item && this.item.item.supplier) {
        return this.item.item.supplier;
      }
      return "N/A";
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("MMM DD, YYYY");
    },
    getStatusLabel() {
      switch (this.item.status) {
        case "pending_replacement":
          return "Pending Replacement";
        case "replaced_customer":
          return "Customer Replaced";
        case "awaiting_supplier_rma":
          return "Awaiting Supplier RMA";
        case "returned_to_supplier":
          return "Returned to Supplier";
        case "resolved_replaced":
          return "Resolved - Replaced";
        case "resolved_credited":
          return "Resolved - Credited";
        default:
          if (this.item.date_replaced) return "Completed";
          return "Pending";
      }
    },
  },
};
</script>
